import { Api } from "./Api";
import axios from "axios";

/** Demandes de Code PIN en attente (module Clés & accès). */
export class DemandePinApi extends Api {
    constructor() {
        super("cles/demandes-pin");
    }

    getCount(): Promise<number> {
        return axios
            .get(this.apiUrl, { params: { count: 1 } })
            .then(function (response) {
                return response.data.data.nombre;
            });
    }
}
